<template>
  <div class="sm-notification-top gateway">
    <div class="sm-wrap">
      <div
        class="sm-notification-top__gateway sm-small"
        @click="goToSettings"
      >
        <include-svg :name="'icon-warning-sys'" />
        <span v-if="notifType == 'card'">
          Add
          <a
            href="#"
            @click.prevent
          > Credit Card </a>
          to gain access
        </span>
        <span v-else>
          Payment Gateway is not added. Please add a&nbsp;
          <a
            href="#"
            @click.prevent
          >Payment Gateway</a>
        </span>
        <a
          v-if="$route.name != 'admin-settings'"
          href="#"
          class="sm-notification-top__gateway-close"
          @click.stop="closeNotif"
        >
          <include-svg :name="'icon-action-close'" />
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'payment-notification',
  props: {
    notifType: {
      type: String,
      required: true // values: card, gateway
    }
  },
  methods: {
    goToSettings() {
      this.$router.push(`/admin/settings?tab=payments&add=${this.notifType == 'card' ? '2' : '1'}`);
    },
    closeNotif(e) {
      e.preventDefault();
      
      if (this.notifType == 'card')
        localStorage.setItem('no-card-closed', true);
      else
        localStorage.setItem('no-gateway-closed', true);

      this.$emit('close', this.notifType);
    }
  }
}
</script>